import React from 'react';
import SEO from '@/components/SEO';
import Navbar from '@/components/landing/Navbar';
import HeroSection from '@/components/landing/HeroSection';
import ShopifyIntegration from '@/components/landing/ShopifyIntegration';
import PainPoints from '@/components/landing/PainPoints';
import TrustBar from '@/components/landing/TrustBar';
import Achievements from '@/components/landing/Achievements';
import ValueProps from '@/components/landing/ValueProps';
import FeaturesGrid from '@/components/landing/FeaturesGrid';
import DashboardSection from '@/components/landing/DashboardSection';
import HowItWorks from '@/components/landing/HowItWorks';
import ProvenAtScale from '@/components/landing/ProvenAtScale';
import FAQSection from '@/components/landing/FAQSection';
import FinalCTA from '@/components/landing/FinalCTA';
import Footer from '@/components/landing/Footer';

const Index = () => (
  <div className="min-h-screen bg-white">
    <SEO
      title="Multi-Courier Shipping Platform for eCommerce"
      description="Boxd Logistics is an end-to-end shipping aggregator helping eCommerce brands automate multi-courier dispatch, tracking, and RTO prediction from a single dashboard."
      keywords="shipping aggregator, ecommerce logistics platform, multi courier shipping, order tracking, RTO prediction, cross border shipping, India shipping API"
      canonical="https://boxdlogistics.in/"
    />
    <Navbar />
    <HeroSection />
    <ShopifyIntegration />
    <PainPoints />
    <TrustBar />
    <Achievements />
    <ValueProps />
    <FeaturesGrid />
    <DashboardSection />
    <HowItWorks />
    <ProvenAtScale />
    <FAQSection />
    <FinalCTA />
    <Footer />
  </div>
);

export default Index;